module.exports = __webpack_public_path__ + "img/3.aab1bc3e.png";